const mail = ({ ...data }) => ({
  method: "POST",
  url: "/mail/send",
  data: { ...data },
});

export const mailApi = {
  mail,
};
